module.exports = __webpack_public_path__ + "img/mesa_el_r.ad9d7c4a.png";